export default {
	navbar: {
		login: 'Iniciar sesión',
		home: 'Hogar',
		register: 'Inscribirse',
		industryTemplate: 'Modelo da indústria',
		cloudTemplate: 'Plantillas de nube',
		cloudData: 'Datos de nube',
		printSetting: 'Configuración de impresión',
		moreSetting: 'Más ajustes',
		user: 'Centro Personal',
		unit: 'Unidad',
		logout: 'Cerrar sesión',
		error404: 'Error404',
		renamePassword: 'Cambiar contraseña',
		editLabel: 'Editar etiqueta',
		member: 'Centro de Miembros',
		suggest: 'Feedback',
		download: 'Descargar Software',
		help: 'Centro de ayuda',
		bind: 'Vincular la cuenta',
		onlineTool: 'Utilidades',
		expansion: 'Amplíe el espacio en la nube',
		pdfPrint: 'Impresión de documentos',
		sharingTemplates: 'Plantilla compartida',
		printRecord: 'Imprimir registros',
		dataRecovery: 'Recuperación de datos',
		myPrinter: 'Mi impresora',
		cloudService: 'Servicios en la nube'
	},
	button: {
		login: 'Iniciar sesión',
		register: 'Inscribirse',
		getCode: 'Enviar',
		print: 'Imprimir ahora',
		editLabel: 'Editar la etiqueta',
		copyLabel: 'Copiar la etiqueta',
		rename: 'Rebautizar',
		delete: 'Borrar',
		createLabel: 'Crear una nueva etiqueta',
		move: 'Mover',
		createFile: 'Crear una nueva carpeta',
		upload: 'Subir',
		cancel: 'Cancelar',
		confirm: 'Estás seguro',
		save: 'Salvar',
		create: 'Crear',
		saveToCloudTem: 'Guardar en la plantilla de nube',
		download: 'Descargar',
		updateAvatar: 'Modifica tu avatar',
		forgetPass: 'Olvidé mi contraseña',
		set: 'Construir',
		goRegister: 'Regístrese ahora',
		goLogin: 'Iniciar sesión',
		backLogin: 'Iniciar sesión',
		reset: 'Restablecimiento',
		useEmail: 'Regístrate por email',
		usePhone: 'Regístrate con tu teléfono',
		labelset: 'Configuración de etiquetas',
		printLabel: 'Impresión',
		exitEdit: 'Salida',
		choose: 'Elegir',
		help: 'Ayuda',
		downloadPC: 'Descargar Software',
		Renewal: 'Renovación',
		Upgrade: 'Actualizar membresía',
		bingLogin: 'Enlazar e iniciar sesión',
		upgradeMember: 'Ir de inmediato',
		exchange: 'Código de canje',
		exchangeNow: 'Canjear ahora',
		expansion: 'Expansión',
		abandon: 'Renunciar',
		logout: 'Cancelación de la cuenta',
		IconicLiteracy: 'Nueva Visión',
		保存到云端: 'Guardar en la nube',
		保存为PNG: 'Guardar como PNG',
		保存为JPEG: 'Guardar como JPEG',
		保存为PDF: 'Guardar como PDF',
		游客: 'Turistas'
	},
	lang: {
		chinese: 'Chinês simplificado',
		english: 'Inglês',
		portuguese: 'Português',
		Spanish: 'Español',
		Russian: 'Ruso',
		Persian: 'Persa'
	},
	tips: {
		tip1: 'Inicio de sesión correcto',
		tip2: '¿Está seguro de que desea eliminar la carpeta y todos los datos que contiene?',
		tip3: '¿Está seguro de que desea eliminar estos datos?',
		tip4: '¿Está seguro de que desea eliminar esta etiqueta?',
		tip5: 'Introduzca un nombre/tamaño de etiqueta',
		tip6: 'Por favor, ingrese a una industria',
		tip7: 'Por favor, introduzca su número de teléfono móvil/dirección de correo electrónico',
		tip8: 'Introduzca el código de verificación',
		tip9: 'Establezca una nueva contraseña',
		tip10: 'Confirme la nueva contraseña',
		tip11: 'Introduzca una contraseña',
		tip12: 'Introduzca un nombre de usuario',
		tip13: 'Por favor, introduzca su número de teléfono',
		tip14: 'Por favor, establezca una contraseña',
		tip15: 'Por favor, confirme la contraseña',
		tip16: 'Seleccione una industria',
		tip17: 'Por favor, introduzca su dirección de correo electrónico',
		tip18: 'Introduzca el número de teléfono móvil/dirección de correo electrónico correcto',
		tip19: 'Marque el acuerdo de lectura',
		tip20: 'Introduzca el número de teléfono correcto',
		tip21: 'Introduzca la dirección de correo electrónico correcta',
		tip22: 'La contraseña introducida dos veces es incoherente',
		tip23: 'Si no encuentras resultados, prueba otra cosa',
		tip24: 'Aún no hay contenido',
		tip25: 'Ven y crea tu etiqueta',
		tip26: '¡Seleccione el archivo de formato tprt/tprts!',
		tip27: 'Error de carga',
		tip28: 'Eliminar correctamente',
		tip29: '¡Seleccione png, jpg, jpeg, xlsx, xls, archivo de formato csv!',
		tip30: 'El archivo es demasiado grande para cargarlo, por favor cargue menos de',
		tip31: 'Archivo K!',
		tip32: '¿Aún no tienes una cuenta?',
		tip33: '¿Ya tienes una cuenta?',
		tip34: 'Modificación exitosa',
		tip35: 'Replicación correcta',
		tip36: 'Seleccione una capa',
		tip37: 'Pegar correctamente',
		tip38: '¡Los códigos de barras no pueden tener caracteres chinos!',
		tip39: '¡Seleccione la imagen en formato JPG, JPEG, PNG!',
		tip40: 'No hay imágenes en la nube',
		tip41: 'El nombre no puede estar vacío',
		tip42: 'El nombre de archivo no puede contener ninguno de los caracteres siguientes:',
		tip43: 'Los apodos no pueden estar vacíos',
		tip44: 'La modificación es exitosa y será redirigido a la página de inicio de sesión',
		tip45: 'Si el archivo ya existe se sobrescribe',
		tip46: '¡Error de red!',
		tip47: 'El archivo es demasiado grande, ¡use un cliente de PC para abrirlo!',
		tip48: 'Modificación exitosa',
		tip49: 'Error de modificación',
		tip50: 'El contenido de la plantilla no puede estar vacío',
		tip51: 'Seleccione una sola capa',
		tip52: 'Seleccione al menos un dato',
		tip53: 'Introduzca palabras clave',
		tip54: 'Código de verificación enviado con éxito',
		tip55: 'Registro exitoso',
		tip56: 'Agregado correctamente',
		tip57: 'La mudanza fue exitosa',
		tip58: 'Guardado con éxito',
		tip59: 'Enviado correctamente',
		tip60: 'Sube imágenes de menos de 2M',
		tip61: 'El contenido no puede estar vacío',
		tip62: 'La carpeta actual no tiene datos cargados',
		tip63: 'Para la seguridad de su cuenta, por favor adquiera su número de teléfono móvil / dirección de correo electrónico!',
		tip64: '¡Conectado con éxito!',
		tip65: '¡La conexión falló!',
		tip66: '¡Encuadernación exitosa!',
		tip67: '¡Use el permiso para modificar el apodo después de actualizar la membresía!',
		tip68: '¡Autorización exitosa!',
		tip69: 'El tamaño de fuente se muestra de manera anormal, ¡ajuste el tamaño de fuente mínimo del navegador!',
		tip70: '¿Cómo modificar?',
		tip71: 'Puntas',
		tip72: '¡Se ha asociado con otros elementos, y no se puede asociar con un elemento!',
		tip73: 'Introduzca un número decimal de 0 ~ 9',
		tip74: 'Introduzca un número hexadecimal que conste de 0 a 9, de la A a la F',
		tip75: 'Introduzca un número hexadecimal que conste de la A a la Z',
		tip76: 'Por favor, introduzca 0~9, A~Z compuesto por treinta-hexadecimales',
		tip77: 'Los datos actuales están referenciados por otro elemento, ¿es seguro eliminarlos?',
		tip78: 'Existen los datos actuales a los que hacen referencia otros elementos, ¿es seguro eliminarlos?',
		tip79: 'Se recomienda utilizar los navegadores Chrome y Microsoft Edge para editar o imprimir etiquetas.',
		tip80: '¡El formato de codificación es incorrecto!',
		tip81: 'Verificación de seguridad',
		tip82: '¿No puedes ver con claridad? Cambiar uno',
		tip83: '¡Las impresiones no pueden estar vacías!',
		tip84: 'Seleccione una impresora',
		tip85: 'Haga clic ',
		tip86: 'en Descargar para instalar e iniciar',
		tip87: ' el Asistente de impresión',
		tip88: 'Si está instalado e iniciado, haga clic aquí para ',
		tip89: 'conectarse',
		tip90: 'No se pudo obtener la impresora, vuelva a conectar el Asistente de impresión.',
		tip91: '¡Entregado con éxito!',
		tip92: 'Error en la entrega, inténtalo de nuevo.',
		tip93: '¡Instale e inicie el Asistente de impresión!',
		tip94: 'Pago exitoso',
		tip95: 'Tiempo de espera de pago',
		tip96: 'Por favor, introduzca el código de canje',
		tip97: 'Instrucciones de uso',
		tip98: 'Los códigos de canje se pueden obtener participando en las actividades oficiales de operación realizadas por Hanma;',
		tip99: 'Proceso de canje: verifique la información de la cuenta, complete el código de canje y haga clic en Canjear ahora;',
		tip100: 'Si usted es miembro, el período de validez de la membresía se extenderá después del canje;',
		tip101: 'Por favor, preste atención al tiempo de canje y canjee dentro del período de validez de canje.',
		tip102: 'Redención exitosa',
		tip103: 'Error de análisis de plantilla',
		tip104: 'La función de formulario es un privilegio solo para miembros, ¡úsela después de actualizar su membresía!',
		tip105: '¡Ábralo con un navegador de computadora!',
		tip106: 'Por favor, elija la carpeta a eliminar',
		tip107: 'No datos',
		tip108: 'Por favor, elija el control a operar',
		tip109: 'Desbloquee primero los controles bloqueados',
		tip110: 'Por favor, seleccione los datos',
		tip111: 'Falló la generación',
		tip112: 'El control está bloqueado',
		tip113: 'Por favor, seleccione la imagen',
		tip114: 'Por favor, seleccione un modelo',
		tip115: '¿Está seguro de que desea eliminar la carpeta seleccionada y todos los datos de la carpeta?',
		tip116: '¡Tener al menos una carpeta!',
		tip117: 'Si guardar el contenido editado actual',
		tip118: '¡Las etiquetas inteligentes se dividen en privilegios exclusivos de los miembros, ¡ por favor, actualice los miembros y usarlos!',
		tip119: '¡Cortar personalizado como un privilegio exclusivo de los miembros, ¡ por favor, actualice los miembros y usarlos!',
		tip120: '¡Cancelación exitosa!',
		tip121: '¡Los datos se limpiarán después de la cancelación, ¡ por favor, actúe con precaución! ¡Si desea seguir usando el Código han después de cancelar, ¡ necesita volver a registrar su cuenta!',
		tip122: 'Control bloqueado',
		tip123: 'Control desbloqueado',
		tip124: 'Introduzca el contenido del texto',
		tip125: '¡Esta fuente es un privilegio exclusivo de los miembros, ¡ por favor, use después de actualizar los miembros!',
		tip126: 'Falló la carga de la fuente',
		tip127: 'Falló la carga del archivo de plantilla',
		tip128: 'Falló la carga de la plantilla',
		tip129: '¡Por favor, apriete el Código de barras!',
		tip130: 'La solicitud es demasiado frecuente, inténtelo de nuevo en 1 minuto',
		tip131: 'Cuando la versión del Código Hanxin es mayor de 30, no admite mostrar texto',
		tip132: '¡La red actual no está conectada, ¡ por favor, conecte la red primero!',
		tip133: 'Por favor, abra la función de impresión y registro primero.',
		tip134: 'Por favor, elija la serie',
		tip135: 'Por favor, elija el modelo.',
		tip136: 'Añadir hasta 10 tamaños comunes',
		tip137: 'Conservar al menos un tamaño de uso común',
		tip138: 'El nuevo mapa es un privilegio exclusivo de los miembros, por favor actualice los miembros y usarlo.',
		tip139: 'Por favor, suba el archivo primero.',
		tip140: 'Por favor, seleccione la plantilla',
		tip141: 'Introduzca el ancho',
		tip142: 'Por favor, introduzca la altura'
	},
	label: {
		label1: 'Pasta',
		label2: 'Etiquetas usadas recientemente',
		label3: 'Nome',
		label4: 'Edite el nombre de la carpeta',
		label5: 'Edite el nombre del archivo',
		label6: 'Editar el nombre de la etiqueta',
		label7: 'Modificar el apodo',
		label8: 'Editar el apodo',
		label9: 'Cambia la contraseña',
		label10: 'Apodo',
		label11: 'Cuenta',
		label12: 'Contraseña',
		label13: 'Industria',
		label14: 'Seleccione la industria',
		label15: 'Revisar',
		label16: 'El nombre de la etiqueta',
		label17: 'Guarde la etiqueta en',
		label18: 'Mover la etiqueta a',
		label19: 'Vista previa de impresión',
		label20: 'Tamaño de la etiqueta',
		label21: 'El tipo de plantilla',
		label23: 'Ancho',
		label24: 'Altura',
		label25: 'Varias filas y columnas',
		label26: 'Columnas',
		label27: 'Filas',
		label28: 'Espaciado',
		label29: 'Espaciado',
		label30: 'Margen',
		label31: 'Margen izquierdo',
		label32: 'Margen derecho',
		label33: 'En el borde',
		label34: 'Bajo el margen',
		label35: 'Creé',
		label36: 'Nombre de datos',
		label37: 'Agregar fecha',
		label38: 'Defecto',
		label39: 'Nombre A-Z',
		label40: 'Nombre Z-A',
		label41: 'Fecha ASC',
		label42: 'Fecha DESC',
		label43: 'Tamaño ASC',
		label44: 'Tamaño DESC',
		label45: 'Login con cuenta',
		label46: 'Cambiar contraseña',
		label47: 'He leído y estoy de acuerdo ',
		label48: 'Acuerdo de servicio ',
		label49: 'y ',
		label50: 'Política de privacidad',
		label51: 'Nueva carpeta 1',
		label52: 'Actualice a los miembros para disfrutar de privilegios exclusivos',
		label53: 'WeChat Paga',
		label54: 'WeChat',
		label55: 'Actualizar miembros para disfrutar de ',
		label63: ' privilegios de miembro',
		label56: 'Recomendar',
		label57: 'Expira {day} días después',
		label59: 'Vencimiento {date}',
		label60: 'Caduca hoy',
		label61: ' meses',
		label62: 'Inicio de sesión de terceros',
		label64: 'Impresora',
		label65: 'Copias',
		label66: 'Preferencial',
		label67: 'Todas las carpetas',
		label68: "Se han seleccionado <span style='color: #003591'>{ total }</span> carpetas",
		label69: 'Gestión',
		label70: 'Año',
		label71: 'Login con código',
		label72: 'Etiqueta personalizada',
		label73: 'Creación de etiquetas',
		label74: 'Nuevo papel de etiqueta',
		label75: 'Selección del modelo',
		label76: 'Tamaño de uso común',
		label77: 'Tamaño personalizado',
		label78: 'Nuevo',
		label79: 'Nº',
		label80: 'Copias'
	},
	privilege: {
		privilege1: 'Aumentar el espacio en la nube',
		privilege2: 'Código de escaneo nuevo',
		privilege3: 'Carpetas ilimitadas',
		privilege4: 'Escanear Imprimir',
		privilege5: 'Comparte Plantillas',
		privilege6: 'Impresión Rápida',
		privilege7: 'Plantillas Variables',
		privilege8: 'Fuentes Exclusivas',
		privilege9: 'Función de Tabla',
		privilege10: 'Imprimir Registro',
		privilege11: 'Modificar Apodo',
		privilege12: 'Estatus Distinguido',
		privilege13: 'Espacio en la nube'
	},
	editAttr: {
		attrText1: 'Propiedades del componente',
		attrText2: 'Origen de datos',
		attrText3: 'Texto normal',
		attrText4: 'Texto de la base de datos',
		attrText5: 'Serializar texto',
		attrText6: 'Fuente',
		attrText7: 'Tamaño',
		attrText8: 'Estilo',
		attrText9: 'Girar',
		attrText10: 'Palabras',
		attrText11: 'Línea',
		attrText12: 'Ajuste de palabras',
		attrText13: 'Espejo',
		attrText14: 'Anti-Negro',
		attrText15: 'Ubicación',
		attrText16: 'Fecha',
		attrText17: 'Cifra',
		attrText18: 'Tipo de hora',
		attrText19: 'Hora del sistema',
		attrText20: 'Especifique la hora',
		attrText21: 'Tipo de código de barras',
		attrText22: 'Ubicación de los datos',
		attrText23: 'No se muestra',
		attrText24: 'Abajo',
		attrText25: 'Multiplicador de zoom',
		attrText26: 'Izquierda',
		attrText27: 'Centro',
		attrText28: 'Derecha',
		attrText29: 'Tasa de corrección de errores',
		attrText30: 'Fotos locales',
		attrText31: 'Imágenes en la nube',
		attrText32: 'Escala igual',
		attrText33: 'El tipo de línea',
		attrText34: 'Grosor de línea',
		attrText35: 'Tipo de dato',
		attrText36: 'Por favor, seleccione',
		attrText37: 'Conectarse',
		attrText38: 'Insertar datos',
		attrText39: 'Contenido inicial',
		attrText40: 'Incremento',
		attrText41: 'Cantidad',
		attrText42: 'Formato de número',
		attrText43: 'Formato de fecha',
		attrText44: 'Seleccione una hora',
		attrText45: 'Radio de esquina',
		attrText46: 'Ajuste al lienzo',
		attrText47: 'Por favor, introduzca el contenido',
		attrText48: 'Líneas sólidas',
		attrText49: 'Discontinua',
		attrText50: 'Copiar',
		attrText51: 'Asalto',
		attrText52: 'Cerradura',
		attrText53: 'Abrir',
		attrText54: 'Alinear',
		attrText55: 'Alineado a la izquierda',
		attrText56: 'Centrar verticalmente',
		attrText57: 'Alineado a la derecha',
		attrText58: 'Centrar horizontalmente',
		attrText59: 'Alineación superior',
		attrText60: 'Alineación inferior',
		attrText61: 'Distribuido horizontalmente',
		attrText62: 'Distribuido verticalmente',
		attrText63: 'Orden de capas',
		attrText64: 'Arriba',
		attrText65: 'De abajo hacia afuera',
		attrText66: 'Borrar',
		attrText67: 'Datos en la nube',
		attrText68: 'Datos locales',
		attrText69: 'Anular',
		attrText70: 'Recuperar',
		attrText71: 'Salvar',
		attrText72: 'Guardar como',
		attrText73: 'Borrar',
		attrText74: 'Ascender',
		attrText75: 'Mover hacia abajo',
		attrText76: 'Mover a la izquierda',
		attrText77: 'Mover a la derecha',
		attrText78: 'Seleccionar todo',
		attrText79: 'Impresión',
		attrText80: 'Acercar el lienzo',
		attrText81: 'Alejar el lienzo',
		attrText82: 'Selección múltiple',
		attrText83: 'La rueda está arriba',
		attrText84: 'Desplácese hacia abajo',
		attrText85: 'Click izquierdo',
		attrText86: 'Guía para principiantes',
		attrText87: 'Ver accesos directos',
		attrText88: 'Descripciones de teclas de atajo',
		attrText89: 'Ajuste a la ventana',
		attrText90: 'Disminuir el zoom',
		attrText91: 'Agrandar',
		attrText92: 'Tipo serializado',
		attrText93: 'Decimal',
		attrText94: 'Alinear',
		attrText95: 'Contrapesar(d)',
		attrText96: 'Contrapesar(m)',
		attrText97: 'Imagen de fondo',
		attrText98: 'Datos',
		attrText99: 'Imprime imagen de fondo',
		attrText100: 'Seleccionar datos',
		attrText101: 'Valor objeto',
		attrText102: 'Agregar datos',
		attrText103: 'Hexadecimal',
		attrText104: 'Letras',
		attrText105: 'Letras y numeros',
		attrText106: 'Altura de línea',
		attrText107: 'Ancho de columna',
		attrText108: 'Contenido',
		attrText109: 'Insertar filas',
		attrText110: 'Insertar una columna',
		attrText111: 'Eliminar la fila',
		attrText112: 'Eliminar la columna',
		attrText113: 'Fusionar',
		attrText114: 'Partir',
		attrText115: 'Formato de hora',
		attrText116: 'Abajo',
		attrText117: 'Llenar',
		attrText118: 'Prefijo',
		attrText119: 'Sufijo',
		attrText120: 'Tiempo',
		attrText121: 'Dirección de la línea',
		attrText122: 'Imágenes en la nube',
		attrText123: 'Pavimentación',
		attrText124: 'Estiramiento',
		attrText125: 'Texto horizontal',
		attrText126: 'Texto vertical',
		attrText127: 'Texto curvo',
		attrText128: 'Engrosar',
		attrText129: 'Cursiva',
		attrText130: 'Subrayado',
		attrText131: 'Eliminar líneas',
		attrText132: 'GRID',
		attrText133: 'Bloqueo de lienzo',
		attrText134: 'Desbloqueo del lienzo',
		attrText135: 'Área',
		attrText136: 'China continental',
		attrText137: 'Estados Unidos',
		attrText138: 'Reino Unido',
		attrText139: 'Moneda',
		attrText140: 'Porcentaje',
		attrText141: 'Punto decimal',
		attrText142: 'Eliminar el 0 final',
		attrText143: 'Símbolo',
		attrText144: 'Mostrar lista',
		attrText145: 'Usar primera fila',
		attrText146: 'Versión',
		attrText147: 'Codificación'
	},
	module: {
		editText1: 'Texto',
		editText2: 'Hora',
		editText3: 'Código de barras',
		editText4: 'Código QR',
		editText5: 'Imagen',
		editText6: 'Forma',
		editText7: 'Rectángulo',
		editText8: 'rectángulo de filete',
		editText9: 'Rombo',
		editText10: 'Elíptico',
		editText11: 'Triángulo',
		editText12: 'Rectángulo sólido',
		editText13: 'Icono',
		editText14: 'Línea',
		editText15: 'Horizonte',
		editText16: 'Vertical',
		editText17: 'Mesa'
	},
	guide: {
		guideText1: 'Bienvenido a ',
		guideText2: 'Simple y eficiente',
		guideText3: 'Orientado a la escena',
		guideText4: 'Recursos útiles',
		guideText5: 'Interoperabilidad multiterminal',
		guideText6:
			'El software de diseño de etiquetas HereLabel permite que el diseño de etiquetas logre lo que ve, es lo que obtiene. Se puede completar simplemente arrastrando y soltando. El diseño de etiquetas nunca ha sido tan simple y eficiente. ¡Ven y experiméntalo!',
		guideText7: 'Saltar',
		guideText8: 'Empieza a aprender',
		guideText9: 'Guía: Modelo da indústria',
		guideText10: 'Las plantillas de etiquetas basadas en escenarios proporcionan etiquetas comunes en varias industrias, como la venta al por menor, la ropa y los códigos de barras.',
		guideText11: 'Guía: Plantilla de nube',
		guideText12: 'Las etiquetas personales se almacenan automáticamente en la nube, se pueden crear etiquetas de administración de carpetas y las etiquetas se pueden usar en PC y terminales móviles.',
		guideText13: 'Guía: Datos en la nube',
		guideText14: 'Los archivos como imágenes y tablas se pueden almacenar permanentemente en la nube y se pueden usar en cualquier momento y en cualquier lugar en la Web, PC y terminales móviles.',
		guideText15: 'Guía: Centro personal',
		guideText16: 'Haga clic para modificar el idioma, cambie la unidad o ingrese a la página del centro personal para modificar la información.',
		guideText17: 'Guía: Nueva etiqueta',
		guideText18: 'Establezca el nombre de la etiqueta, el tamaño, la cantidad de filas y la cantidad de columnas, ¡y comience a crear su propia etiqueta!',
		guideText19: 'Entendido',
		guideText20: 'Empezar a crear etiquetas',
		guideText21: 'Bienvenido a la página de edición',
		guideText22: 'Solo unos simples pasos para completar la edición de la etiqueta, ¡venga y aprenda juntos!',
		guideText23: 'Bibliotecas de componentes',
		guideText24: 'Se proporcionan varios componentes, como texto, hora, código de barras, etc., y los componentes correspondientes se pueden agregar haciendo clic o arrastrando con el mouse.',
		guideText25: 'Sigue aprendiendo',
		guideText26: 'Área de funciones',
		guideText27: 'Las funciones de los componentes incluyen bloquear, deshacer, restaurar, alinear, capa en la parte superior, capa en la parte inferior, copiar, pegar y eliminar.',
		guideText28: 'También puede hacer clic con el botón derecho en el componente en el lienzo para abrir el menú contextual para la operación.',
		guideText29: 'Área de atributos',
		guideText30: 'Seleccione el componente para abrir el área de atributos, modifique la fuente de datos, el estilo, el tamaño, la posición y otros atributos del componente correspondiente.',
		guideText31: 'Guardar Imprimir',
		guideText32:
			'Haga clic en la configuración de la etiqueta para modificar el tamaño de la etiqueta actual. <br />Después de terminar de editar la etiqueta, puede intentar imprimir la etiqueta actual.',
		guideText33: 'He aprendido',
		guideText34: 'Próximo',
		guideText35:
			'El software de diseño de etiquetas HereLabel permite que el diseño de etiquetas logre lo que ve, es lo que obtiene. Se puede completar simplemente arrastrando y soltando. El diseño de etiquetas nunca ha sido tan simple y eficiente. ¡Ven y experiméntalo!',
		guideText36: 'Guía: impresión de documentos',
		guideText37: 'Soporte para word, Excel、PPT、PDF、 Imágenes y otros formatos',
		guideText38: 'Guía: servicios en la nube',
		guideText39:
			'Proporciona funciones de gestión y almacenamiento en línea seguras y eficientes, incluyendo plantillas en la nube, datos en la nube, bases de datos de información de productos básicos, plantillas de productos básicos, plantillas compartidas, registros de impresión, recuperación de datos'
	},
	suggest: {
		suggest1: 'Tipo de pregunta',
		suggest2: 'Función anómala',
		suggest3: 'Consejo de producto',
		suggest4: 'Descripción del problema',
		suggest5: '¡Describa el problema que encontró en detalle y lo resolveremos lo antes posible!',
		suggest6: 'Detalles de contacto',
		suggest7: 'Por favor ingrese su información de contacto',
		suggest8: 'Captura de pantalla del problema',
		suggest9: 'Enviar'
	},
	document: {
		text1: 'Abrir el documento',
		text2: 'Haga clic o arrastre y suelte el archivo directamente en esta área para cargarlo',
		text3: 'Corte automático',
		text4: 'Corte inteligente de etiquetas',
		text5: 'Corte personalizado',
		text6: 'Impresión directa',
		text7: 'Documentación',
		text8: 'Un clic para cortar el vacío excesivo del documento',
		text9: 'División de etiquetas inteligentes',
		text10: 'Cortar a varios archivos de etiqueta',
		text11: 'Líneas',
		text12: 'Columnas',
		text13: 'Ejemplo',
		text14: 'Por ejemplo: 2 * 2',
		text15: 'Siguiente paso',
		text16: 'Tamaño del papel',
		text17: 'Personalizado',
		text18: 'Ancho',
		text19: 'Altura',
		text20: 'Efecto de impresión',
		text21: 'Documentos',
		text22: 'Imagen',
		text23: 'Resolución',
		text24: 'Modo de disposición',
		text25: 'Extender',
		text26: 'Relleno',
		text27: 'Proporción',
		text28: 'Número de copias impresas',
		text29: 'Rango de página',
		text30: 'Todo',
		text31: 'Página actual',
		text32: 'Rango de página',
		text33: 'Rango de página (por ejemplo: 1-3,5)',
		text34: 'Paso anterior',
		text35: 'Corte',
		text36: 'Por favor, suba el archivo txt, pptx, ppt, pdf, doc, docx, xls, xlsx, bp, jpg, png',
		text37: 'El contenido del documento está vacío',
		text38: 'Entrada incorrecta del rango de página',
		text39: 'Error de análisis',
		text40: 'Aplicar todo el documento'
	},
	expandCloud: {
		text1: 'Se ha utilizado',
		text2: 'Espacio total',
		text3: 'Registro de compra',
		text4: 'Espacio de compra',
		text5: 'Fecha de compra',
		text6: 'Válido hasta',
		text7: 'No hay registro de compra por el momento',
		text8: 'Paquete de expansión',
		text9:
			'El paquete espacial entrará en vigor dentro de los 5 minutos posteriores a la compra exitosa; El espacio comprado se reciclará después de que expire, pero se conservarán los archivos subidos.'
	},
	industryTemplate: {
		text1: 'Selección del modelo',
		text2: 'Más',
		text3: 'Buscar contenido',
		text4: 'Condiciones de selección',
		text5: 'Tamaño de la plantilla',
		text6: 'Ancho de la plantilla',
		text7: 'Altura de la plantilla',
		text8: '{tempCount} plantillas',
		text9: 'Modelos de interruptores',
		text10: 'Contenido de selección',
		text11: 'Seleccionar Serie'
	},
	shareTemplates: {
		共享管理: 'Gestión compartida',
		共享码: 'Código compartido',
		我共享的: 'Lo comparto',
		共享给我: 'Comparte conmigo',
		'共享模板为会员专属特权，请升级会员后使用': 'La plantilla compartida es un privilegio exclusivo de los miembros, por favor actualice los miembros y use',
		添加共享码: 'Añadir código compartido',
		当前共享人数: 'Número actual de personas compartidas',
		设置共享文件夹: 'Configurar carpetas compartidas',
		全部关闭: 'Todos cerrados',
		全部开启: 'Todos abiertos',
		'开启共享后，他人可通过您分享的共享码，打印您共享文件夹内的模板！':
			'¡¡ después de abrir el intercambio, otros pueden imprimir la plantilla dentro de su carpeta compartida a través del Código compartido que comparte!',
		分享: 'Compartir',
		有效期: 'Período de validez',
		'1天': '1 día',
		'7天': '7 días',
		'30天': '30 días',
		'该有效期为会员专属特权，请升级会员后使用': 'Este período de validez es un privilegio exclusivo de los miembros. por favor, use después de actualizar los miembros.',
		分享码已生成并复制: 'El Código compartido se ha generado y copiado',
		确定退出该shared_by_name的共享文件: 'Asegúrese de salir del archivo compartido de ese { shared_by_name }',
		成员管理: 'Gestión de miembros',
		已选中total个成员: 'Se han seleccionado {total} miembros',
		暂无成员: 'Sin miembro por el momento',
		请选择要删除的成员: 'Por favor, elija el miembro a eliminar',
		请输入共享码: 'Por favor, introduzca el Código compartido',
		'关闭后好友将无法打印您的模板，是否确定关闭？': '¿Después del cierre, los amigos no podrán imprimir su plantilla, ¿ está seguro de cerrarla?',
		'他人可通过您分享的共享码打印您共享文件夹内的模板！': '¡¡ otros pueden imprimir la plantilla dentro de su carpeta compartida a través del Código compartido que comparte!',
		开启并分享: 'Abrir y compartir'
	},
	printRecord: {
		打印记录: 'Imprimir registros',
		'关闭后，打印记录将无法存储在您的个人云端': 'Después de cerrar, los registros de impresión no se podrán almacenar en tu nube personal.',
		打印份数: 'Número de copias impresas',
		编辑: 'Edición',
		是否删除打印记录: 'Si eliminar el registro impreso',
		'开启打印记录后，将存储你的打印记录到你个人的云端': 'Después de abrir el registro de impresión, guarde su registro de impresión en su nube personal.',
		'非VIP用户可存储最近7天打印记录，VIP用户用户可存储最近3个月打印记录':
			'Los usuarios no VIP pueden almacenar los registros de impresión de los últimos 7 días, mientras que los usuarios VIP pueden almacenar los registros de impresión de los últimos 3 meses.',
		总打印份数: 'Número total de copias a imprimir'
	},
	dataRecovery: {
		数据恢复: 'Recuperación de datos',
		'支持恢复最近6个月删除的模板、Excel及图片！': '¡¡ soporte para restaurar plantillas, Microsoft e imágenes eliminadas en los últimos 6 meses!',
		还原: 'Restaurar',
		还原模板至: 'Restaurar la plantilla a',
		还原数据至: 'Restaurar datos a',
		恢复成功: 'Recuperación exitosa',
		模板: 'Plantilla',
		文件: 'Documentos',
		图片: 'Imagen',
		'数据恢复为会员专属特权，请升级会员后使用': 'La recuperación de datos es un privilegio exclusivo para miembros, por favor actualice su membresía para utilizarlo.'
	},
	myPrinter: {
		云打印机: 'Impresora en la nube',
		'非4G云打印机请在汉码App上配网绑定后使用！': '¡¡ las impresoras en la nube no 4G deben usarse después de la vinculación de la red en la aplicación de código han!',
		解绑: 'Desatar',
		添加打印机: 'Añadir impresoras',
		请输入设备序列号: 'Introduzca el número de serie del dispositivo',
		该设备不支持: 'El dispositivo no admite',
		解绑成功: 'Desatar con éxito',
		'验证码已下发，请查看打印机': 'Se ha emitido el Código de verificación, consulte la impresora',
		绑定成功: 'Vinculación exitosa',
		'请输入打印机编码(IMEI号)': 'Introduzca el Código de la impresora (número imei)',
		请输入打印机打印出来的验证码: 'Introduzca el Código de verificación impreso por la impresora',
		设备序列号: 'Número de serie del dispositivo',
		打印机IMEI号: 'Número IMEI de la impresora',
		验证码: 'Código de verificación',
		暂无设备: 'Sin equipo por el momento'
	},
	printLabel: {
		驱动打印: 'Imprimir por driver',
		云打印: 'Impresora nube',
		'暂无在线设备，请开启设备或前往我的打印机页面进行添加设备':
			'No hay dispositivos en línea por el momento, abra el dispositivo o vaya a la página de <a style="color:#003591;cursor:pointer" href="myPrinter">mi impresora</a> para agregar el dispositivo',
		'无在线云打印设备，请选择驱动打印': 'No hay dispositivos de impresión en la nube en línea, elija conducir para imprimir',
		下发成功: 'Emisión exitosa',
		下发失败: 'Emisión fallida',
		名称: 'Nombre',
		尺寸: 'Tamaño'
	},
	iconicLiteracy: {
		'支持pdf，png，jpg，jpeg格式': 'Soporte pdf, png, jpg, formato jpeg',
		'请上传pdf，png，jpg，jpeg格式': 'Por favor, suba el formato pdf, png, jpg, JPEG',
		读取失败: 'Falló la lectura',
		'每日限时试用total次，今日剩余count/total次': 'Prueba {total} veces al día y <span style="color:#003591;">{count}</span>/{total} veces más hoy',
		'今日试用次数已用完，请明日再来体验!': '¡El número de pruebas de hoy se ha agotado, ¡ por favor, vuelva a experimentarlo mañana!'
	},
	goodsInfo: {
		商品信息库: 'Biblioteca de Información de Productos',
		商品模板: 'Plantilla de Producto',
		数据绑定: 'Vinculación de Datos',
		绑定成功: 'Vinculación Exitosa',
		字段名: 'Nombre del Campo',
		'还有数据未绑定数据库字段，未绑定的数据将默认为固定数据，是否确认编辑完成？':
			'Algunos datos no están vinculados a los campos de la base de datos. Los datos no vinculados se tratarán como fijos. ¿Desea confirmar la finalización?',
		自定义字段: 'Campo Personalizado',
		新建商品模板: 'Crear Nueva Plantilla de Producto',
		设为默认: 'Establecer como Predeterminado',
		默认: 'Predeterminado',
		批量打印: 'Impresión por Lotes',
		新建商品: 'Crear Nuevo Producto',
		手动录入: 'Entrada Manual',
		excel导入: 'Importar desde Excel',
		清空商品数据: 'Borrar Datos de Productos',
		编辑: 'Editar',
		已选count项数据: '{count} elementos seleccionados',
		'默认商品模板不存在，请刷新后重试': 'La plantilla de producto predeterminada no existe. Actualiza e inténtalo de nuevo.',
		请先选择要打印的商品数据: 'Seleccione primero los datos del producto que desea imprimir',
		操作: 'Acción',
		请选择导入的文件: 'Seleccione el archivo para importar',
		选择文件: 'Seleccionar Archivo',
		获取模板: 'Obtener Plantilla',
		导入excel文件格式要求: 'Requisitos del Formato del Archivo Excel',
		'1、名称、条码必须填写，其他选填；2、商品数量条数限制为：2000条；3、列名请按如下格式及顺序填写':
			'1. El nombre y el código de barras son obligatorios; los demás son opcionales. 2. Límite: 2000 artículos. 3. Los nombres de las columnas deben seguir el formato y el orden indicados.',
		'请上传.xls,.xlsx格式的文件': 'Suba un archivo .xls o .xlsx',
		导入成功: 'Importación Exitosa',
		导入失败: 'Error de Importación',
		导入: 'Importar',
		请选择文件夹: 'Seleccione una carpeta',
		请输入: 'Por favor, introduzca',
		编辑商品: 'Editar Producto',
		当前商品使用字段: 'Campos Actuales del Producto',
		'1、名称、条码为必须字段': '1. El nombre y el código de barras son obligatorios',
		'2、会员可自定义商品字段名称及新增字段': '2. Los miembros pueden personalizar los nombres de los campos y agregar nuevos',
		使用当前字段: 'Usar Campos Actuales',
		'名称、条码为必填字段，会员可自定义商品字段名称及新增字段': 'El nombre y el código de barras son obligatorios. Los miembros pueden personalizar y agregar nuevos campos.',
		新增字段: 'Agregar Campo',
		编辑字段: 'Editar Campo',
		请输入字段名称: 'Introduzca el nombre del campo',
		'自定义字段为会员专属特权，请升级会员后使用': 'Los campos personalizados son una función exclusiva para miembros. Actualice su membresía para usarla.',
		请输入字符长度小于32的字段名称: 'Introduzca un nombre de campo de menos de 32 caracteres',
		'仅支持中文、英文、空格和数字组合': 'Solo se admiten caracteres chinos, letras, espacios y números',
		'字段名称重复，请重新修改！': 'El nombre del campo está duplicado. Modifíquelo.',
		最多支持20个字段: 'Se admiten hasta 20 campos',
		'您确定要清空此文件夹所有数据吗？': '¿Está seguro de que desea borrar todos los datos de esta carpeta?',
		'删除字段后，关联的商品字段信息将会清除，是否继续？': 'Después de eliminar el campo, se borrará la información asociada. ¿Desea continuar?',
		批量删除: 'Eliminación masiva',
		请先选择要删除的商品数据: 'Seleccione primero los datos del producto que desea eliminar.',
		'您确定要删除所选中的数据吗？': '¿Está seguro de que desea eliminar los datos seleccionados?'
	}
};
